import React from 'react';
import PropTypes from 'prop-types';
import AppStore from '../../stores/AppStore';
import * as AppActions from '../../actions/AppActions';
import TemplateData, {
  localsMessages,
  guestLocalsMessages,
} from '../../utility/getTemplateData';
import { showSpinnerOverlay, hideSpinnerOverlay } from '../../utility/helper';
import SingleAmount from '../../components/amount/SingleAmount';
import CancelAndReturn from '../../components/cancelAndReturn';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import _isEmpty from 'lodash/isEmpty';
import _find from 'lodash/find';
import DonateGiftAid from '../../guest-payment-components/DonateGiftAid';
import * as FPT from '../../utility/fpt';
import CurrencyConversionModal from '../../components/currencyConversion/CurrencyConversionModal';
import {
  normalizeNumber,
  formatCurrencyAsString,
  exchangeRateDecimalPoints,
} from '../../utility/formator';
import { withRouter } from 'react-router-dom';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import {
  setCountryAndLocale,
  parseErrorResponse,
  observeUntilEventObserved,
} from '../../utility/helper';
import { fetcher } from '../../utility/domUtils';
import CVVComponent from '../../containers/cvv-component';
import withDonate from '../../components/guest/WithDonate';
import ThreeDSContainer from '../../components/threeDS/ThreeDSContainer';
import {
  Alert,
  Button,
  CaptionText,
  BodyText,
  grey600,
} from '@paypalcorp/pp-react';
import getContent from 'pp-react-l10n';
import CloseButton from '../../components/CloseButton';
import BackButton from '../../components/BackButton';
import DonateHeader from '../../components/common/DonateHeader';
import { isExternalFlow } from '../../utility/externalIntegrationUtils';
import { isInContext } from '../../utility/inContextDonation';

let giftAidText = localsMessages('common/giftAidIt');
const donateGiftPercentage = AppStore.getGiftAidItExtraAmount();
let giftAidTextObj = (giftAidText && giftAidText.giftAidIt) || {};
let { extraCost } = giftAidTextObj;
const guestMessages = guestLocalsMessages('guest/guestForm');
const messages = localsMessages('guest/crossBorder');
const errorMessages = localsMessages('errors/service');

const STYLES = StyleSheet.create({
  donateBtnContainer: {
    maxWidth: '360px',
    margin: '20px auto 0px',
  },
  donateBtn: {
    marginBottom: 0,
  },
  centralFormWrapper: {
    maxWidth: '500px',
    width: '100%',
    margin: '0 auto',
    padding: '0 18px',
  },
  donationSeparator: {
    marginBottom: '25px',
  },
  formTopLabelBold: {
    fontWeight: 'bold',
    marginTop: 31,
    fontSize: 15,
  },
  formLabelLeft: {
    width: '70%',
    fontSize: 15,
    textAlign: 'left',
  },
  formLabelRight: {
    width: '30%',
    fontSize: 15,
    textAlign: 'right',
  },
  formLabelLeftConv: {
    width: '70%',
    fontSize: 12,
    textAlign: 'left',
  },
  formLabelRightConv: {
    width: '30%',
    fontSize: 12,
    textAlign: 'right',
  },
  formLabelCenter: {
    width: '100%',
    marginTop: '10px',
    textAlign: 'center',
  },

  formLabelRateLeft: {
    width: '70%',
    fontSize: 12,
    textAlign: 'left',
  },
  formLabelRateRight: {
    width: '30%',
    fontSize: 12,
    textAlign: 'right',
  },
  conversionRate: {
    maxWidth: '500px',
    width: '100%',
    padding: '0 18px',
    margin: '12px auto 0',
  },
  policyMsg: {
    fontSize: '0.85em',
    textAlign: 'center',
    color: '#848B8E',
  },
  labelFont: {
    fontSize: 12,
  },
  link: {
    color: '#0270ba',
  },
  currencyConversionOptionsLink: {
    paddingLeft: '12px',
  },
});

const DYNAMIC_CURRENCY_CONVERSION_TAG = 'DYNAMIC_CURRENCY_CONVERSION';
export const CURRENCY_CONVERSION_OPTIONS = {
  PAYPAL: 'PAYPAL',
  ISSUER: 'ISSUER',
};

class CrossBorder extends React.Component {
  constructor(props) {
    super(props);

    let isRecurring = AppStore.getDonationRecurring() === 'checked';
    const stateConversionWithPayPal = this.getStateForConversionWithPayPal();

    this.state = {
      subHeaderLabel: TemplateData.donationName,
      donationId: AppStore.getSelectedProgram() || TemplateData.donationId,
      orgName: TemplateData.charityName,
      amountDecimalPoint: TemplateData.donationDecimalPoint || '.',
      decimalPoint: TemplateData.donationDecimalPoint || '.',
      isRecurring,
      ...stateConversionWithPayPal,
      showCVVField: false,
      securityCode: '',
      isCurrencyConversionModalOpen: false,
    };
  }

  endCustomCPLTracking = () => {
    const spinnerOverlay = document.getElementById('spinnerOverlay');

    if (spinnerOverlay.style.display === 'none') {
      // From tesla flow we don't have the spinner
      window.PAYPAL.analytics.endCPLTracking({
        page: 'main:donate:wps:guest:crossBorder:web::',
        action: 'crossborder_page_loaded',
        uicomp: 'crossBorder',
        uitype: 'page',
      });
    } else {
      // From guest form we need to wait for the spinner to disappear
      observeUntilEventObserved(
        spinnerOverlay,
        { attributes: true },
        (observer) => {
          if (spinnerOverlay.style.display === 'none') {
            window.PAYPAL.analytics.endCPLTracking({
              page: 'main:donate:wps:guest:crossBorder:web::',
              action: 'crossborder_page_loaded',
              uicomp: 'crossBorder',
              uitype: 'page',
            });

            observer.disconnect();
            return;
          }
        }
      );
    }
  };

  componentDidMount() {
    this.endCustomCPLTracking();
  }

  getStateForConversionWithPayPal() {
    let fundingOptions = AppStore.getFundingOptions();
    let [fundingSources] = fundingOptions ? fundingOptions.sources : [];
    let paymentNetwork = fundingSources.payment_card.network.toLowerCase();
    paymentNetwork =
      paymentNetwork.charAt(0).toUpperCase() + paymentNetwork.slice(1);
    let paymentDigits = fundingSources.payment_card.last_4;
    let exchangeRate = parseFloat(
      fundingOptions.currency_conversion.exchange_rate
    ).toString();
    let fundsIn = fundingOptions.currency_conversion.funds_in;
    let fundsOut = fundingOptions.currency_conversion.funds_out;

    return {
      exchangeRate,
      paymentCard: `${paymentNetwork} x-${paymentDigits}`,
      inAmount: fundsIn.value,
      inCurrency: fundsIn.currency,
      inSymbol: fundsIn.symbol,
      outAmount: fundsOut.value,
      outCurrency: fundsOut.currency,
      outSymbol: fundsOut.symbol,
      currencyConversionOption: CURRENCY_CONVERSION_OPTIONS.PAYPAL,
    };
  }

  getStateForConversionWithIssuer() {
    let amount = AppStore.getDonationAmount();
    let symbol = AppStore.getDonationSymbol();
    let currency = AppStore.getDonationCode();

    // No currency_conversion. fundsIn and fundsOut will not be available.
    return {
      amount,
      symbol,
      currency,
      currencyConversionOption: CURRENCY_CONVERSION_OPTIONS.ISSUER,
    };
  }

  updateFundingOptionsState() {
    let fundingOptions = AppStore.getFundingOptions();
    if (!fundingOptions.currency_conversion) {
      this.setState(this.getStateForConversionWithIssuer());
    } else {
      this.setState(this.getStateForConversionWithPayPal());
    }
  }

  getLocalizedCurrency = (amount, currency) => {
    let formatedAmount = {
      value: parseFloat(amount).toFixed(2),
      currency: currency,
    };
    let newAmount = formatCurrencyAsString(formatedAmount);
    return newAmount;
  };

  handleCurrencyConversionClick = () => {
    FPT.trackLinkClick('showCurrencyConversionModal');
    this.showCurrencyConversionModal();
  };

  showCurrencyConversionModal = () => {
    this.setState({
      isCurrencyConversionModalOpen: true,
    });
  };

  hideCurrencyConversionModal = () => {
    this.setState({
      isCurrencyConversionModalOpen: false,
    });
  };

  handleDonateClick = () => {
    if (this.state.showCVVField) {
      const cvv = document.getElementById('securityCode').value;
      this.childCVVInfo.handleFieldBlur(
        cvv,
        'errorMessageCSC',
        'REQUIRED_SECURITY_CODE',
        'INVALID_SECURITY_CODE'
      );

      let hasError =
        document.getElementsByClassName('vx_has-error-with-message').length > 0;
      if (!cvv || hasError) {
        return;
      }
    }
    const fundingOptions = AppStore.getFundingOptions();
    const contingencies = _get(fundingOptions, 'contingencies') || [];
    const threeDSContingency =
      _find(contingencies, { action: '3D_SECURE_DATA_COLLECTION_REQUIRED' }) ||
      {};

    if (!_isEmpty(threeDSContingency)) {
      this.threeDSContainer.initializeThreeDS();

      FPT.addFi(
        fundingOptions,
        'main:donate:wps:guest:crossborder',
        'main:donate:wps:guest:crossborder:web::'
      );

      return;
    }

    // All contingencies resolved
    this.processDonation();
  };

  processDonation = () => {
    showSpinnerOverlay();

    return this.props.doFulfilment({
      securityCode: this.state.securityCode,
    });
  };

  handleGiftAidOption = (giftAidState) => {
    AppActions.updateGiftaidItFlag({ giftAidItFlag: giftAidState });
  };

  updateGiftAidComponent = (state) => {
    const extraCostText = getContent('locals')('common/giftAidIt')(
      'giftAidIt.extraCost',
      {
        currency: state.outSymbol,
        amount: state.outAmount,
        extraAmount: (donateGiftPercentage * state.outAmount).toFixed(2),
      },
      {
        useHTML: true,
      }
    );

    let modalp1 = (giftAidTextObj && giftAidTextObj.modalp1) || '',
      modalp2 = (giftAidTextObj && giftAidTextObj.modalp2) || '',
      applyGiftAid = (giftAidTextObj && giftAidTextObj.applyGiftAid) || '';

    modalp1 = modalp1 && modalp1.replace('{orgName}', state.subHeaderLabel);
    modalp2 = modalp2 && modalp2.replace('{orgName}', state.subHeaderLabel);
    applyGiftAid =
      applyGiftAid && applyGiftAid.replace('{orgName}', state.subHeaderLabel);

    giftAidTextObj.extraCost = extraCostText;
    giftAidTextObj.modalp1 = modalp1;
    giftAidTextObj.modalp2 = modalp2;
    giftAidTextObj.applyGiftAid = applyGiftAid;
  };

  handleOptionSelection = (option) => {
    const beforeOption = this.state.currencyConversionOption;
    this.setState(
      {
        currencyConversionOption: option,
      },
      () => {
        // Do Planning if the option has changed
        if (beforeOption !== option) {
          this.hideCurrencyConversionModal();
          showSpinnerOverlay();
          this.getFundingOptions().finally(() => {
            hideSpinnerOverlay();
          });
        } else {
          setTimeout(() => {
            this.hideCurrencyConversionModal();
          }, 300);
        }
      }
    );
  };

  showCVVComponent() {
    this.setState({
      showCVVField: true,
    });
  }

  hideCVVComponent() {
    this.setState({
      showCVVField: false,
    });
  }

  getFundingOptions() {
    const lastFundingSource = this.getLastFundingSource();
    const paymentCardId = _get(lastFundingSource, 'payment_card.id');

    const currencyConversionType = this.state.currencyConversionOption;

    return fetcher('/donate/guest/fundingOptions', {
      method: 'POST',
      body: JSON.stringify({
        amount: normalizeNumber(AppStore.getDonationAmount()),
        code: AppStore.getDonationCode(),
        fundingOptionId: AppStore.getFundingOptions().id,
        preferences: {
          currency_conversion: [
            {
              payment_card_id: paymentCardId,
              type: currencyConversionType,
              validity: 'TRANSACTION',
            },
          ],
        },
        consentShareAddress: AppStore.getShareAddress(),
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log('getFundingOptions result :: ', result);

        let fundingOptions;
        // The funding options data format returned by the server is
        // different for ISSUER and PAYPAL. Handle it appropriately.

        // For conversion with 'ISSUER'
        if (currencyConversionType === CURRENCY_CONVERSION_OPTIONS.ISSUER) {
          fundingOptions = _get(result, 'data.fundingOpt[0]');
        } else {
          // For conversion with 'PAYPAL'
          fundingOptions = _get(result, 'fundingOpts[0]');
        }

        // Handle error case where fundingOptions call succeeds
        // but no data is returned
        if (_isEmpty(fundingOptions)) {
          FPT.trackError({
            message: 'FUNDING_OPTIONS_EMPTY_CROSSBORDER',
            code: currencyConversionType,
          });
          this.props.history.push('/donate/error/payment');
          return;
        }

        // If CVV contingencies are present and has not been resolved,
        // then display cvv component
        const contingencies = _get(fundingOptions, 'contingencies');
        const hasCvvContingency = _find(contingencies, {
          action: 'CVV_REQUIRED',
        });
        const isCvvContingencyResolved = _get(
          result,
          'data.contingencyResolutionStatus.cvvContingencyResolved',
          false
        );

        if (hasCvvContingency && !isCvvContingencyResolved) {
          this.showCVVComponent();
        } else {
          this.hideCVVComponent();
        }

        // Updating store with funding options
        AppActions.updateFundingOptions({ fundingOptions });

        this.updateFundingOptionsState();

        console.log(result);
      })
      .catch(() => {
        console.log('FAILED');
        this.props.history.push('/donate/error/payment');
      })
      .finally(() => {
        hideSpinnerOverlay();
      });
  }

  renderConversionRateInfo(exchangeRate, fundsOut) {
    const label = _get(messages, 'label', {});
    return (
      <div className="ppvx_row">
        <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
          <div>
            <CaptionText style={{ color: grey600 }}>
              {label.conversion} {exchangeRate}
            </CaptionText>
          </div>
          <div>
            <CaptionText style={{ color: grey600 }}>{fundsOut}</CaptionText>
          </div>
        </div>
      </div>
    );
  }

  getLastFundingSource() {
    let fundingOptions = AppStore.getFundingOptions();
    const fundingSources = fundingOptions.sources || [];
    return fundingSources[fundingSources.length - 1];
  }

  /**
   * Returns true if currency conversion options should be displayed
   * @param  {Array} fundingSources Funding Sources
   * @return {Boolean}              True if currency conversion options should be displayed
   */
  shouldShowCurrencyConversionOptions = () => {
    const lastFundingSource = this.getLastFundingSource();
    const tags = _get(lastFundingSource, 'tags');
    return _includes(tags, DYNAMIC_CURRENCY_CONVERSION_TAG);
  };

  renderCurrencyConversionOptionsLink(label) {
    const userCountry = AppStore.getUserCountry();

    return (
      <React.Fragment>
        <div className="ppvx_row">
          <div className="ppvx_col-12">
            {this.state.currencyConversionOption ===
            CURRENCY_CONVERSION_OPTIONS.PAYPAL ? (
              <div>
                <CaptionText style={{ color: grey600 }}>
                  {userCountry === 'US' ? label.spread : label.fee}
                </CaptionText>
              </div>
            ) : null}
          </div>
        </div>

        <div className="conversion-options-link ppvx_row">
          <div className="ppvx_col-12">
            <div>
              <a
                href="#"
                style={{ fontSize: 14 }}
                className="ppvx_link pp_cancel_btn"
                id="currencyConversionOptionsLink"
                onClick={this.handleCurrencyConversionClick}
              >
                {label.currencyConversionOptions}
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleSecurityCodeChange = (securityCode) => {
    this.setState({
      securityCode: securityCode,
    });
  };

  handleThreeDSStepUpAuthSuccess = () => {
    this.props.toggleSpinner(true);
    this.props.doFulfilment({
      securityCode: this.state.securityCode,
    });
  };
  handleThreeDSStepUpAuthFailure = () => {
    // Unrecoverable error !!
    this.props.history.push('/donate/error/payment');
  };

  handleThreeDSFailure = () => {
    // Unrecoverable error !!
    this.props.history.push('/donate/error/threeDS');
  };

  render() {
    const inAmount = this.getLocalizedCurrency(
      this.state.inAmount,
      this.state.inCurrency
    );
    const outAmount = this.getLocalizedCurrency(
      this.state.outAmount,
      this.state.outCurrency
    );
    const fundsIn = _includes(inAmount, this.state.inCurrency)
      ? `${inAmount}`
      : `${inAmount} ${this.state.inCurrency}`;
    const fundsOut = _includes(outAmount, this.state.outCurrency)
      ? `${outAmount}`
      : `${outAmount} ${this.state.outCurrency}`;
    const exchangeRate = `${this.getLocalizedCurrency(
      '1.00',
      this.state.inCurrency
    )} = ${exchangeRateDecimalPoints(
      this.state.exchangeRate,
      this.state.amountDecimalPoint,
      this.state.inSymbol
    )} ${this.state.outCurrency}`;
    const { label = {} } = messages || {};
    let donateNowRecurring = _get(guestMessages, 'guestLabels.donatenowrec');
    donateNowRecurring =
      donateNowRecurring && donateNowRecurring.replace('{amount}', fundsOut);

    const formattedDonationAmount = `${
      this.state.symbol ? this.state.symbol : ''
    }${this.state.amount} ${this.state.currency}`;

    let giftaidFlag = AppStore.getGiftaidItFlagStatus();
    this.updateGiftAidComponent(this.state);

    let { csc: cscLabel, cscwarning } = guestMessages.guestLabels;
    cscwarning =
      cscwarning && cscwarning.replace('{csc}', cscLabel.toLowerCase());

    const { showCVVField } = this.state;

    return (
      <div
        className={`${
          TemplateData.bannerUrl ? 'gn_donate_wrapper' : 'donate_wrapper'
        } ${isInContext() ? 'context_gn_wrapper' : ''}`}
      >
        {showCVVField && (
          <div className="ppvx_row alert-container mb-8">
            <div className="ppvx_col-12">
              <Alert type="attention">{cscwarning}</Alert>
            </div>
          </div>
        )}

        <DonateHeader />
        {isExternalFlow() && (
          <>
            <BackButton />
            <CloseButton />
          </>
        )}

        <div id="crossBorderContainer" className="ppvx_container cross-border">
          {/* <Amount
                        amount={outAmount}
                        symbol={this.state.outSymbol}
                        decimalPoint={this.state.decimalPoint}
                        code={this.state.outCurrency}/> */}

          {TemplateData.isGiftaiditEnabled && (
            <DonateGiftAid
              isAlreadyEnrolled={giftaidFlag}
              showAddress={false}
              addressData=""
              isChecked={giftaidFlag}
              handleGiftAidOption={this.handleGiftAidOption}
              contentMsg={giftAidTextObj}
            />
          )}

          <div className="alignment-padding">
            <div className="ppvx_row">
              <div className="ppvx_col-12">
                <BodyText strong style={{ margin: '28px 0' }}>
                  {label.donatingFrom}
                </BodyText>
              </div>
            </div>
            <div className="ppvx_row">
              <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
                <div>
                  <BodyText>{this.state.paymentCard}</BodyText>
                </div>
                <div>
                  {this.state.currencyConversionOption ===
                  CURRENCY_CONVERSION_OPTIONS.PAYPAL
                    ? fundsIn
                    : formattedDonationAmount}
                </div>
              </div>
            </div>

            <div className="ppvx_row">
              <div className="ppvx_col-12">
                {showCVVField && (
                  <CVVComponent
                    onRef={(ref) => (this.childCVVInfo = ref)}
                    handleSecurityCodeChange={this.handleSecurityCodeChange}
                  />
                )}
              </div>
            </div>
          </div>

          {this.state.currencyConversionOption ===
          CURRENCY_CONVERSION_OPTIONS.PAYPAL ? (
            <div className="ppvx_row">
              <div className="ppvx_col-12">
                <div className="conversion-block alignment-padding">
                  <div className="ppvx_row">
                    <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
                      <div>
                        <BodyText as="span">{label.youllDonate}</BodyText>
                      </div>
                      <div>
                        <BodyText as="span">{fundsIn}</BodyText>
                      </div>
                    </div>
                  </div>

                  <div className="ppvx_row">
                    <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
                      <div>
                        <CaptionText as="span">{label.convertsTo}</CaptionText>
                      </div>
                      <div>
                        <CaptionText as="span">{fundsOut}</CaptionText>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="conversion-block alignment-padding">
              <div className="ppvx_row">
                <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-between ppvx_align-items-center">
                  <div>
                    <CaptionText as="span">{label.youllDonate}</CaptionText>
                  </div>
                  <div>
                    <CaptionText as="span">
                      {formattedDonationAmount}
                    </CaptionText>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="alignment-padding">
            {this.state.currencyConversionOption ===
              CURRENCY_CONVERSION_OPTIONS.PAYPAL &&
              this.renderConversionRateInfo(exchangeRate, fundsOut)}
            {this.shouldShowCurrencyConversionOptions() &&
              this.renderCurrencyConversionOptionsLink(label)}
            <div style={{ height: '40px' }} />

            <div className="ppvx_row">
              <div className="ppvx_col-12 legal-text text-center">
                {getContent('locals')('guest/crossBorder')(
                  'label.policies',
                  { country: TemplateData.country },
                  { useHTML: true }
                )}
              </div>
            </div>

            <div style={{ height: '20px' }} />
          </div>

          <div className="ppvx_row">
            <div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
              <Button
                className="btn-wide"
                id="donate-button"
                disabled={this.props.disabled}
                onClick={this.handleDonateClick}
              >
                {this.state.isRecurring ? donateNowRecurring : label.donatenow}
              </Button>
            </div>
          </div>
          <div style={{ height: '24px' }} />

          <CancelAndReturn />
          <CurrencyConversionModal
            isOpen={this.state.isCurrencyConversionModalOpen}
            exchangeRate={exchangeRate}
            handleOptionSelection={this.handleOptionSelection}
            hideModal={this.hideCurrencyConversionModal}
            selectedOption={this.state.currencyConversionOption}
          />

          <ThreeDSContainer
            onThreeDSStepUpAuthNotRequired={this.handleThreeDSStepUpAuthSuccess}
            onThreeDSStepUpAuthSuccess={this.handleThreeDSStepUpAuthSuccess}
            onThreeDSStepUpAuthFailure={this.handleThreeDSFailure}
            onThreeDSFailure={this.handleThreeDSFailure}
            onRef={(ref) => (this.threeDSContainer = ref)}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(withDonate(CrossBorder));
